import {useCallback} from 'react';
import type {Media} from 'api/types';
import {Configuration} from 'configuration';
import {getMediaUrl} from 'api/media';
import {useGetTokens} from 'services/auth';
import {useSnacks} from 'components/snacks';

export const useDownloadFile = (
  file: Media,
  mock?: boolean,
): {
  download: () => Promise<void>;
} => {
  const getTokens = useGetTokens();
  const {errorSnack} = useSnacks();

  const download = useCallback(() => {
    return getMediaUrl(file.id, getTokens, mock)
      .then(url => {
        return fetch(url, {
          method: 'GET',
          referrer: Configuration.app.domain,
          credentials: 'include',
        });
      })
      .then(response => {
        if (response.ok) {
          return response.blob();
        } else {
          throw new Error('Empty blob');
        }
      })
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${file.id}.${file.extension}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(e => {
        errorSnack('Download failed: ' + e);
      });
  }, [file.id, file.extension, getTokens, mock, errorSnack]);

  return {
    download,
  };
};
